import { render, staticRenderFns } from "./pandianDetailItem.vue?vue&type=template&id=11ec28e7&scoped=true&"
import script from "./pandianDetailItem.vue?vue&type=script&lang=js&"
export * from "./pandianDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./pandianDetailItem.vue?vue&type=style&index=0&id=11ec28e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ec28e7",
  null
  
)

export default component.exports